<form [formGroup]="form">
    <div class="card-inline full-width">
        <div>
            <app-valorization-amount-control [isDisabled]="isDisabled" [isRegistered]="isRegistered" [editableAgreementPriceIds]="editableAgreementPriceIds" (onRecalculateClick)="recalculateClick()" (onAddPracticeClick)="addPracticeClick($event)" (onAddSetInsumoClick)="addSetInsumoClick($event)"
                (onRefreshPractice)="refreshPractice($event)" (onRefreshPracticeToParticular)="refreshPracticeToParticular($event)" [loading]="loading" formControlName="ValorizationAmount">
            </app-valorization-amount-control>
        </div>
        <div class="margin-top-medium">
            <div class="card-inline">
                <h4>
                    <span [matBadge]="totalDocumentationItems" matBadgeColor="accent" matBadgeOverlap="false">Documentaciones requeridas</span
          >
        </h4>

      </div>
      <mat-divider></mat-divider>

      <app-documentation-item-control
        [isDisabled]="isDisabled"
        [loading]="loading"
        formControlName="DocumentationItems"
      >
      </app-documentation-item-control>
    </div>
    <div class="card-inline full-width">
      <button
        [disabled]="findingNormative"
        color="accent"
        (click)="verNormas()"
        mat-flat-button
      >
        Normas
      </button>
        <button
        style="margin-left: 10px;"
          *ngIf="receivedLabSampleEnabled"
          color="accent"
          (click)="verMuestras()"
          mat-flat-button
        >
          Muestras
        </button>
    </div>
  </div>
</form>